import { Outlet } from "react-router-dom";
import UniversalObjectDrawer from "./UniversalObjectDrawer";

const EntityDrawerWrapper = () => (
  <>
    <Outlet />
    <UniversalObjectDrawer />
  </>
);

export default EntityDrawerWrapper;
